export default __webpack_public_path__ + "static/tibial-sloped-notext-6240219da88401287cfea85411c9c14f.jpg";